import React from "react";
const { useDispatch } = require("react-redux");
const { useState } = require("react");
const { addCategory } = require('../../../redux/actions/admin');
const { useSelector } = require("react-redux");

function AddCategory() {

  const [Name, setName] = useState();
  const [Desc, setDesc] = useState();

  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.admin);

  function addUserHandler(e){
    e.preventDefault();
    dispatch(addCategory(Name, Desc, admin._id, admin.name));
  }

  return (
    <div> 
      <div className="section">
        <div className="container">
          <form className="form" onSubmit={addUserHandler} >
            
            <div className="right-side">
              <div className="forms">
                <h1 className="forms-heading">ADD CATEGORY</h1>
                <div className="form-inputs">
                  <i className="fa fa-tag"></i>
                  <input type="text" placeholder="category name"
                    name="categoryname" 
                    value={Name ? Name : ""}
                    onChange={(e) => setName(e.target.value)}
                  required />
                </div>
                
                <div className="form-inputs">
                  <i className="fa fa-message"></i>
                  <textarea type="text" placeholder="category description"
                    name="categorydescription"
                    rows="4" 
                    value={Desc ? Desc : ""}
                    onChange={(e) => setDesc(e.target.value)}
                  required />
                </div>
                
                
                
                <div className="sign-button">
                  <button type="submit">ADD Category</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCategory;
